<!--样式引入-->
<style scoped lang="scss" src="./index.scss"></style>

<!--模版引入-->
<template lang="pug" src="./index.pug"></template>

<script>
import { pinyin } from 'pinyin-pro';
export default {
  components: {},
  data() {
    return {
      indexList: ['A','B','C','D','E','F','G','H','I','J','K','L','M','N','O','P','Q','R','S','T','U','V','W','X','Y','Z','#'],
      indexData: [],

      ly_column:[],   //领域
      yq_column:[],   //医荟

      realName:null,    //搜索词
      domainId: null,   
      title: null,

      timeout: null,
    };
  },

  watch: {
    
  },
  created: function() {
  },
  mounted: function() {
    //获取领域
    this.$api.domainPage().then((res) => {
      var ly_data = res.data.data || [];
      var ly_arr = [];
      ly_data.map(r=>{
        ly_arr.push({
          text: r.name,
          value: r.id
        })
      })
      ly_arr.splice(0,0,{text:'全部',value:null})
      this.ly_column = ly_arr;
    });
    //获取专家标签
    this.$api.getByType("USER_TITLE").then((res) => {
      var bq = res.data || [];
      bq.splice(0,0,{text:'全部',value:null})
      this.yq_column = bq;
    });
    this.getZjList();
  },
  methods: {
    

    //选择领域
    confirmLy(e){
      console.log(e);
      this.domainId = e.value.value;
      this.getZjList();
    },
    //医荟认证
    confirmYq(e){
      console.log(e);
      this.title = e.value.value;
      this.getZjList();
    },
    //筛选医生
    onFilter(e){
      var v = e.target.value;
      if(this.$glf.isEmpty(v)){
        return false;
      }
      clearTimeout(this.timeout);
      this.timeout = setTimeout(()=>{
        this.getZjList();
      },500)
    },

    //获取全部专家
    getZjList() {
      var params = {
        condition: {
          stc: "1 and 2 and 3",
          items: [
            { code: "domainId", opc: this.domainId?"=":"like", values: [this.domainId===null?'':this.domainId] },
            { code: "realName", opc: "like", values: [this.realName===null?'':this.realName] },
            { code: "title", opc: this.title?"=":"like", values: [this.title===null?'':this.title] },
          ],
        },
      };
      this.$api.userPage(params).then((res) => {
        var data = res.data.data || [];
        //解析姓名的首字母 并处理排序数据
        data.map(r=>{
          var szmArr = pinyin(r.realName,{pattern: 'initial', type: 'array' });
          if(szmArr.length>0){
            if(this.$glf.isEmpty(szmArr[0])){
              r.py = '';
            }else{
              r.py = szmArr[0].toUpperCase().slice(0, 1);
            }
          }else{
            r.py = '';
          }
          return r;
        })
        data = this.$glf.stringSort(data,'py');
        //分组数据
        var duiArr = [];
        data.map(r=>{
          if(this.$glf.isEmpty(r.py)){
            r.py = '#';
          }
          if(duiArr.indexOf(r.py)===-1){
            duiArr.push(r.py);
          }
          return r;
        })
        //插缝数据
        var okData = [];
        var ind = 0;    //指针
        duiArr.map((r,rIndex)=>{
          okData.push({pai:'node',value:r});
          ind += 1;
          data.map((m,mIndex)=>{
            if(r===m.py){
              m.pai = 'user';
              okData.splice(ind,0,m);
              ind += 1;
            }
          })
        })
        this.indexData = okData;
      });
    },
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/expert/expert_all/index.vue